import { Navigate, Route } from "react-router-dom";

import { CRM_PRO_VIEW_ALL_LEAD, CRM_PRO_VIEW_ASSIGNED_LEAD } from "src/constants";
import { CRM_PRO_ROUTES } from "src/pages/crm-pro/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { LeadsAndDashboardPage } from "./LeadsAndDashboard.page";
import { SingleLeadPage } from "./SingleLead.page";

const viewLeadPermissions = [CRM_PRO_VIEW_ALL_LEAD, CRM_PRO_VIEW_ASSIGNED_LEAD];

/** Route tree for the CRM Pro module; `/crm-pro` redirects to the dashboard. */
export const crmProRoutes = (
  <>
    <Route path={CRM_PRO_ROUTES.root} element={<Navigate to={CRM_PRO_ROUTES.dashboard} replace />} />
    <Route
      path={CRM_PRO_ROUTES.dashboard}
      element={<ProtectedRoute permissions={viewLeadPermissions} component={LeadsAndDashboardPage} />}
    />
    <Route
      path={CRM_PRO_ROUTES.leads}
      element={<ProtectedRoute permissions={viewLeadPermissions} component={LeadsAndDashboardPage} />}
    />
    <Route
      path={CRM_PRO_ROUTES.leadDetails}
      element={<ProtectedRoute permissions={viewLeadPermissions} logic="OR" component={SingleLeadPage} />}
    />
  </>
);
